import { getCampaignByIdRequest, getPurchasedCampaignDataFromCRM } from "@common";
import { getCampaignByIdAction } from "@store";

export function* loadCampaignById(action: typeof getCampaignByIdAction.typeInterface) {
    try {
        if (action.mode === "summary") {
            yield* getPurchasedCampaignDataFromCRM.saga({
                clientId: action.clientId,
                campaignId: action.campaignId,
                _q: new Date().getTime()
            });
        } else {
            yield* getCampaignByIdRequest.saga({
                clientId: action.clientId,
                campaignId: action.campaignId
            });
        }
    } catch (e) {
        console.log("Error getting campaign by ID", e);
    }
}
